import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
	selector: 'readonly-wrapper',
	templateUrl: './readonlyWrapper.component.html',
	styleUrls: ['./readonlyWrapper.component.scss']
})
export class ReadOnlyWrapperComponent extends FieldWrapper {

	//#region PROPERTIES

	/** Conteneur pour le champs de formulaire. */
	@ViewChild("fieldComponent", { read: ViewContainerRef, static: true }) public fieldComponent: ViewContainerRef;

	//#endregion
}